(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-before-after"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mc-image-comparison')) {
customElements.define('mc-image-comparison', class extends HTMLElement {
connectedCallback() {
if (this.ready) return; this.ready = true;
const range = this.querySelector('input[type="range"]');
const viewport = this.querySelector('.mc-comparison__viewport');
const update = value => { const next = Math.max(0, Math.min(100, Number(value))); range.value = String(next); this.style.setProperty('--reveal', next + '%'); };
range.addEventListener('input', () => update(range.value));
this.querySelectorAll('[data-reveal]').forEach(button => button.addEventListener('click', () => update(button.dataset.reveal)));
let active = null;
const move = event => { const rect = viewport.getBoundingClientRect(); update((event.clientX - rect.left) / rect.width * 100); };
viewport.addEventListener('pointerdown', event => { if (event.button !== 0) return; active = event.pointerId; viewport.setPointerCapture(event.pointerId); move(event); });
viewport.addEventListener('pointermove', event => { if (active === event.pointerId) move(event); });
const finish = () => { active = null; };
viewport.addEventListener('pointerup', finish); viewport.addEventListener('pointercancel', finish); viewport.addEventListener('lostpointercapture', finish);
}
});
}

  } catch(e) { console.error(e); }
})();
})();
